import { createFileRoute } from '@tanstack/react-router';

import { ProviderQuotesPage } from '@/features/services/provider/quotes-pages';

export const Route = createFileRoute('/_app/me/services/quotes/')({
  component: ProviderQuotesPage,
});
